import { render, staticRenderFns } from "./CreateOtherActive.vue?vue&type=template&id=44f8593e&"
import script from "./CreateOtherActive.vue?vue&type=script&lang=js&"
export * from "./CreateOtherActive.vue?vue&type=script&lang=js&"
import style0 from "./CreateOtherActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports